import { render, staticRenderFns } from "./program-bankgiro-loterij-fonds.vue?vue&type=template&id=c17403b0"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports